export default {
  scheduler: 'Планировщик',
  'scheduler.info': 'Информация о планировщике',
  'scheduler.header.title': 'Планировщик {{entity}} ({{count}})',
  'scheduler.result':
    'Происходит <strong>{{occurs}}</strong>, начиная с {{startAt}}.',
  'scheduler.startedAt': 'Начало',
  'scheduler.duration': 'Повторять каждые',
  'scheduler.occurrences': 'Повторения',
  'scheduler.weekdays.sunday': 'Воскресенье',
  'scheduler.weekdays.monday': 'Понедельник',
  'scheduler.weekdays.tuesday': 'Вторник',
  'scheduler.weekdays.wednesday': 'Среда',
  'scheduler.weekdays.thursday': 'Четверг',
  'scheduler.weekdays.friday': 'Пятница',
  'scheduler.weekdays.saturday': 'Суббота',
  'scheduler.weekdays.short.sunday': 'Вс',
  'scheduler.weekdays.short.monday': 'Пн',
  'scheduler.weekdays.short.tuesday': 'Вт',
  'scheduler.weekdays.short.wednesday': 'Ср',
  'scheduler.weekdays.short.thursday': 'Чт',
  'scheduler.weekdays.short.friday': 'Пт',
  'scheduler.weekdays.short.saturday': 'Сб',
  'scheduler.duration.end': 'Причина окончания',
  'scheduler.duration.endDate': 'Дата окончания',
  'scheduler.duration.end.day': 'В этот день',
  'scheduler.duration.end.after': 'После',
  'scheduler.duration.end.no': 'Без окончания',
  'scheduler.separator.and': ' и',
  'scheduler.separator.on': 'в',
  'scheduler.separator.day': 'день',
  'scheduler.separator.every': 'каждые',
  'scheduler.separator.of': 'из',
  'scheduler.separator.the': '',
  'scheduler.day.first': 'Первый',
  'scheduler.day.second': 'Второй',
  'scheduler.day.third': 'Третий',
  'scheduler.day.fourth': 'Четвёртый',
  'scheduler.day.last': 'Последний',
  'scheduler.weekday': 'Будний день',
  'scheduler.weekend': 'Выходной',
  'scheduler.day': 'День',
  'scheduler.days': 'Дни',
  'scheduler.week': 'Неделя',
  'scheduler.weeks': 'Недели',
  'scheduler.year': 'Год',
  'scheduler.years': 'Годы',
  'scheduler.monthDay': 'День месяца',
  'scheduler.month': 'Месяц',
  'scheduler.months': 'Месяцы',
  'scheduler.months.january': 'Январь',
  'scheduler.months.february': 'Февраль',
  'scheduler.months.march': 'Март',
  'scheduler.months.april': 'Апрель',
  'scheduler.months.may': 'Май',
  'scheduler.months.june': 'Июнь',
  'scheduler.months.july': 'Июль',
  'scheduler.months.august': 'Август',
  'scheduler.months.september': 'Сентябрь',
  'scheduler.months.october': 'Октябрь',
  'scheduler.months.november': 'Ноябрь',
  'scheduler.months.december': 'Декабрь',
  'scheduler.months.short.january': 'Янв',
  'scheduler.months.short.february': 'Фев',
  'scheduler.months.short.march': 'Мар',
  'scheduler.months.short.april': 'Апр',
  'scheduler.months.short.may': 'Май',
  'scheduler.months.short.june': 'Июн',
  'scheduler.months.short.july': 'Июл',
  'scheduler.months.short.august': 'Авг',
  'scheduler.months.short.september': 'Сен',
  'scheduler.months.short.october': 'Окт',
  'scheduler.months.short.november': 'Ноя',
  'scheduler.months.short.december': 'Дек',
  'scheduler.actions.manage': 'Управление планировщиком',
  'scheduler.meta.assignedTo': 'Назначено',
  'scheduler.meta.duration': 'Длительность',
  'scheduler.meta.period': 'Период',
  'scheduler.limited': 'Планировщик ограничен: {{limit}}',
  'scheduler.info.helper': 'Настройте планировщик для периода распродажи.',
};
